<template>
  <layout-auth>
    <v-toolbar flat color="grey lighten-3" height="50px">
      <v-container>
        <a @click="$router.push('/anticipo-automatico')" class="sub-nav">{{
          $t("invoices.Alta")
        }}</a>
        <a @click="$router.push('/anticipo-automatico/baja')" class="sub-nav">{{
          $t("invoices.Baja")
        }}</a>
        <a
          class="sub-nav"
          style="font-weight: bold; color: #222222 !important"
          >{{ $t("invoices.Modificación") }}</a
        >
      </v-container>
    </v-toolbar>

    <v-container class="py-10">
      <v-row>
        <v-col>
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("invoices.anticipoAutomatico") }}
          </h1>
        </v-col>
        <v-col>
          <v-btn
            depressed
            :color="entityConfig.primaryColor"
            class="float-end my-5"
            :style="`color: ${entityConfig.secondaryColor}`"
            @click="$router.push('/anticipo-automatico')"
          >
            {{ $t("invoices.nuevaAlta") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row style="align-items: center">
        <v-col>
          <h2 class="text-h5 font-weight-light">
            {{ $t("invoices.listadoAnticiposAutomaricos") }}
          </h2>
        </v-col>

        <v-col>
          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="showFilter = !showFilter"
            class="float-end m-2"
          >
            <v-icon left> mdi-tune </v-icon>
            {{ $t("invoices.filtrar") }}
          </v-btn>
          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="print"
            class="float-end m-2"
          >
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("supplierData.print") }}
          </v-btn>

          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="downloadExcel"
            class="float-end m-2"
          >
            <v-icon left> mdi-microsoft-excel </v-icon>
            Excel
          </v-btn>
        </v-col>
      </v-row>

      <v-form ref="filterform">
        <v-row class="pt-10" v-show="showFilter">
          <v-col cols="12" sm="12" lg="6">
            <label>{{ $t("invoices.clientName") }}</label>
            <v-autocomplete
              placeholder="Seleccionar Cliente"
              :color="entityConfig.primaryColor"
              :item-color="entityConfig.primaryColor"
              :items="invoicesListClients"
              dense
              no-data-text=""
              item-text="name"
              item-value="numClient"
              outlined
              @change="filterClient()"
              v-model="currentClient"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" lg="3">
            <label>{{ $t("invoices.dateFrom") }}</label>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="true"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFromFormatted"
                  readonly
                  outlined
                  dense
                  :placeholder="$t('invoices.from')"
                  :color="entityConfig.primaryColor"
                  persistent-hint
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="dateFrom = parseDate(dateFromFormatted)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :locale="$i18n.locale"
                @change="filterDateFrom"
                v-model="dateFrom"
                :color="entityConfig.primaryColor"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" lg="3">
            <label>{{ $t("invoices.dateTo") }}</label>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="true"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateToFormatted"
                  readonly
                  outlined
                  dense
                  :placeholder="$t('invoices.to')"
                  :color="entityConfig.primaryColor"
                  persistent-hint
                  append-icon="mdi-calendar"
                  @blur="dateTo = parseDate(dateToFormatted)"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :locale="$i18n.locale"
                @change="filterDateTo"
                v-model="dateTo"
                :color="entityConfig.primaryColor"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-row class="pb-5">
            <v-col cols="12" sm="12" lg="12">
              <v-btn
                @click="resetPaginationAndSearch()"
                depressed
                :color="entityConfig.primaryColor"
                class="float-end m-2 v-btn-width-default"
                :style="`color: ${entityConfig.secondaryColor}`"
              >
                {{ $t("invoices.filtrar") }}
              </v-btn>

              <v-btn
                @click="limpiarFiltros"
                outlined
                :color="entityConfig.primaryColor"
                class="float-end m-2"
              >
                {{ $t("invoices.quitarFiltros") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-row>
      </v-form>

      <v-col class="pt-10" style="padding: 0px">
        <v-divider :color="entityConfig.primaryColor"></v-divider>
        <error-table :erroCode="valCode" :hidden="!noData" />
        <v-data-table
          :hidden="noData"
          fixed-header
          no-data-text="No hay datos que mostrar"
          :checkbox-color="entityConfig.primaryColor"
          :headers="headers"
          :items="invoices"
          :items-per-page="itemsPerPage"
          item-key="id"
          hide-default-footer
        >
          <template v-slot:item.applicationDate="{ item }">
            {{
              dataFormatter.dateFormatter(item.applicationDate, $i18n.locale)
            }}
          </template>
          <template v-slot:item.iban="{ item }">
            {{ dataFormatter.accountNumberFormatter(item.iban) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              :color="entityConfig.primaryColor"
              class="ml-4 float-end"
              @click="editItem(item)"
            >
              mdi-pencil-outline
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
      <v-container>
        <div :hidden="noData" class="text-right">
          <v-row>
            <v-col>
              <paginator
                :hasPrev="hasPrev"
                :hasNext="hasNext"
                :pageNumber="pageNumber"
                @pageone="goToPageOne()"
                @prev="prevPage()"
                @next="nextPage()"
              ></paginator>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-container>
    <invoice-advance-edit-dialog
      :visible="editDialog"
      :anticipo="currentInvoice"
      @closed="editDialog = !editDialog"
    />
    <overlay :visible="spinner"></overlay>
  </layout-auth>
</template>

<script>
import Paginator from "../../components/layouts/paginator.vue";
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import InvoiceAdvanceEditDialog from "./invoice_advance_edit_dialog.vue";
import Api from "../../Services/index";
import Overlay from "../../components/layouts/overlay.vue";
import xlsx from "json-as-xlsx";
import dataFormatter from "../../plugins/dataFormatter";
import ErrorTable from "../../components/layouts/error-table.vue";

export default {
  components: {
    LayoutAuth,
    InvoiceAdvanceEditDialog,
    Overlay,
    Paginator,
    ErrorTable,
  },
  data() {
    return {
      noData: false,
      valCode: 0,
      hasNext: false,
      itemsPerPage: 0,
      paginationIndex: 0,
      pageIndexItems: [],
      dataFormatter: dataFormatter,
      dateFromFormatted: "",
      dateToFormatted: "",
      spinner: false,
      showFilter: false,
      menu1: false,
      menu2: false,
      entityConfig: {},
      currentClient: {},
      accounts: [],
      invoicesListClients: [],
      selectedAccount: "",
      dateFrom: "",
      dateTo: "",
      currentInvoice: {},
      query: {},
      editDialog: false,
      headers: [
        {
          text: "CLIENTE PAGADOR",
          sortable: false,
          value: "nameClient",
        },
        {
          text: "FECHA SOLICITUD",
          sortable: false,
          value: "applicationDate",
        },
        {
          text: "CUENTA DE ABONO",
          sortable: false,
          value: "iban",
        },
        {
          text: "FACTURAS A ANTICIPAR",
          sortable: false,
          width: "30%",
          value: "type",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
          width: "10%",
        },
      ],
      invoices: [],
    };
  },
  mounted() {
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.entityConfig = this.$store.state.entityConfig.config;
    this.getAutomaticAdvances();
    this.getListOfClients();
  },
  watch: {
    dateFrom() {
      this.dateFromFormatted = this.formatDate(this.dateFrom);
    },

    dateTo() {
      this.dateToFormatted = this.formatDate(this.dateTo);
    },
  },
  computed: {
    pageNumber() {
      return this.paginationIndex + 1;
    },
    hasPrev() {
      return this.paginationIndex > 0;
    },
  },
  methods: {
    filterClient() {
      this.query.numCliente = this.currentClient;
    },
    filterDateFrom() {
      this.query.fechaDesde = this.dateFrom;
    },
    filterDateTo() {
      this.query.fechaHasta = this.dateTo;
    },
    nextPage() {
      this.query.paginationItem = this.pageIndexItems[this.paginationIndex++];
      this.getAutomaticAdvances();
    },
    goToPageOne() {
      this.paginationIndex = 1;
      this.prevPage();
    },
    prevPage() {
      this.paginationIndex--;
      if (this.paginationIndex > 0) {
        this.query.paginationItem =
          this.pageIndexItems[this.paginationIndex - 1];
      } else {
        delete this.query.paginationItem;
      }
      this.getAutomaticAdvances();
    },
    resetPaginationAndSearch() {
      delete this.query.paginationItem;
      this.paginationIndex = 0;
      this.pageIndexItems = [];
      this.getAutomaticAdvances();
    },
    getAutomaticAdvances() {
      const qs = Object.keys(this.query)
        .filter(key => this.query[key])
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(this.query[key])}`
        )
        .join("&");
      this.spinner = true;
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let supplierId = userdata.supplierId.trim();
      Api.get(`/proveedores/${supplierId}/anticipos-automaticos?${qs}`)
        .then((res) => {     
          this.invoices = res.data.response.automaticAdvanceInfoList;
          this.hasNext = res.data.response.moreData == 1;
          this.itemsPerPage = this.invoices.length;
          if (!this.pageIndexItems.includes(res.data.response.paginationItem)) {
            this.pageIndexItems.push(res.data.response.paginationItem);
          }
          this.invoices.forEach((x) => (x.type = "Todas las facturas vivas"));
          this.noData = false;
        })
        .catch((error) => {
          this.valCode = error.response.data.code;
          this.noData = true;
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    limpiarFiltros() {
      this.$refs.filterform.reset();
      this.query = {};
    },
    confirmarBaja(anticipo) {
      sessionStorage.setItem("removeThisAutoAdvance", JSON.stringify(anticipo));
      this.$router.push("/anticipo-automatico/baja/confirmar");
    },
    editItem(item) {
      this.currentInvoice = item;
      this.editDialog = true;
    },
    confirmarEdicion(anticipo) {
      sessionStorage.setItem("editThisAutoAdvance", JSON.stringify(anticipo));
      this.$router.push("/anticipo-automatico/baja/confirmar");
    },
    getListOfClients() {
      this.userdata = JSON.parse(sessionStorage.getItem("userData"));
      this.userId = this.userdata.supplierId.trim();
      this.spinner = true;
      Api.get(`/proveedores/${this.userId}/clientes`)
        .then((resp) => {
          this.invoicesListClients = resp.data.response;
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    print() {
      window.print();
    },
    downloadExcel() {
      let data = [
        {
          sheet: "Anticipos",
          columns: [
            { label: "Cliente pagador", value: "nameClient" },
            { label: "Fecha Solicitud", value: "applicationDate" },
            { label: "Cuenta de Abono", value: "iban" },
          ],
          content: this.invoices,
        },
      ];
      let settings = { fileName: "Anticipos" };
      xlsx(data, settings);
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}/${month}/${year}`;
    },
  },
};
</script>
